import lodash, { isEmpty } from 'lodash';
import { MDBDataTable, Alert } from "mdbreact";
import PropTypes from 'prop-types';
import React from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Row,
    Col,
    Button,
  } from "reactstrap";

function calculateAverage(rows, aggregatedDataColumns) {
    var averageRow = [];
    for (let i = 1; i < aggregatedDataColumns.length; i++) {
        var sum= rows.map((x) => x[aggregatedDataColumns[i].label]).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        averageRow.push({metric:aggregatedDataColumns[i].label, value:parseFloat(sum / rows.length).toFixed(2)});
    }
    return averageRow;
}

export function formatAggregatedData(tableData) {
    let aggregatedData = [];
    if (typeof tableData !== undefined && !isEmpty(tableData.columns)) {
        const aggregatedDataColumns = lodash.cloneDeep(tableData.columns);
        aggregatedData = calculateAverage(tableData.rows, aggregatedDataColumns);
    }
    return aggregatedData;
}

export function renameKey ( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

export function formatTableData(arr) {
    if (typeof arr !== undefined && !isEmpty(arr)) {
        var data = JSON.parse(JSON.stringify(arr));
        data.forEach( obj => renameKey( obj, 'complexity', 'cc' ) );
        data.forEach( obj => renameKey( obj, 'totaldebt', 'total debt' ) );
        data.forEach( obj => renameKey( obj, 'k', 'maintainance load (LoC)' ) );
        data = JSON.parse(JSON.stringify(data,["file","total debt", "maintainance load (LoC)","cc",
                        "rfc","mpc","nom","dac","lcom","size1","size2"]));

        const keys = [];
        const columns = [];
        const rows = [];
        if (data.length > 0) {
            keys.push(Object.keys(data[0]));
            for (let i = 0; i < keys[0].length; i++) {
                var key = keys[0][i];
                let column = {
                    'label': '' + key + '',
                    'field': '' + key + '',
                    'sort': 'asc',
                    'width': 150
                };
                columns.push(column);
            }
        }
        rows.push(data);

        const tableData = {
            'columns': columns,
            'rows': rows[0]
        };
        return tableData;
    }

    return {}
}

export default class TableAndAvgMetrics extends React.Component {
    static propTypes = {
        data: PropTypes.any
    }

    render() {
        const tableData = formatTableData(this.props.data);
        let aggregatedData = formatAggregatedData(tableData);

        return (
            <>
                <CardHeader>
                    <CardTitle tag="h5">Average Project Metrics</CardTitle>
                </CardHeader>
                
                <Row>
                    {aggregatedData.map((col) => (
                        <Col lg="2" md="3" sm="3" xs="6">
                            <Card style={{boxShadow:"0px 4px 7px 4px rgba(0, 0, 0, 0.15)"}}>
                                <CardHeader>
                                    <CardTitle tag="h5">{col.metric}</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <h6> {col.value} </h6>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
                
                <br/>

                <CardHeader>
                    <CardTitle tag="h5">All File Metrics</CardTitle>
                </CardHeader>
                <MDBDataTable striped small bordered responsive hover data={tableData} />
            </>
        )
    }
}